var time = "https://shopfront-cdn.tekoapis.com/static/b2c29b7046b45840.svg";

export { time as default };
